export const HOME = { emergentLink: "emergent-link" };

export const TID = {
  // Nav
  navUploads: "nav-uploads",
  navConsensus: "nav-consensus",
  navData: "nav-data",
  navOptimizer: "nav-optimizer",
  navLineups: "nav-lineups",
  navAI: "nav-ai",
  navWarRoom: "nav-war-room",
  // Uploads
  dkUploadInput: "dk-upload-input",
  dkUploadStatus: "dk-upload-status",
  competitorSelect: "competitor-source-select",
  competitorFileInput: "competitor-file-input",
  competitorUploadBtn: "competitor-upload-btn",
  competitorList: "competitor-active-list",
  resetBtn: "reset-app-btn",
  // Data & Vegas
  dataRefreshBtn: "data-refresh-btn",
  vegasTable: "vegas-table",
  qbrTable: "qbr-table",
  defRanksTable: "def-ranks-table",
  scheduleList: "schedule-list",
  // Consensus
  consensusTable: "consensus-table",
  consensusRefresh: "consensus-refresh-btn",
  // Optimizer
  cfgNumLineups: "cfg-num-lineups",
  cfgSalaryFloor: "cfg-salary-floor",
  cfgSumOwnMin: "cfg-sum-own-min",
  cfgSumOwnMax: "cfg-sum-own-max",
  cfgMinLowOwned: "cfg-min-low-owned",
  cfgLowOwnedThresh: "cfg-low-owned-thresh",
  cfgMaxExposure: "cfg-max-exposure",
  cfgVariance: "cfg-variance",
  cfgPrimaryStack: "cfg-primary-stack",
  cfgMaxPerTeam: "cfg-max-per-team",
  cfgStackPOnly: "cfg-stack-primary-only",
  cfgStackPS: "cfg-stack-p-s",
  cfgStackPST: "cfg-stack-p-s-t",
  cfgQbFav: "cfg-qb-fav",
  cfgRbHomeFav: "cfg-rb-home-fav",
  cfgWrItt24: "cfg-wr-itt24",
  cfgTeItt24: "cfg-te-itt24",
  cfgDstOu47: "cfg-dst-ou47",
  generateBtn: "generate-lineups-btn",
  // Lineups
  lineupsTable: "lineups-table",
  exportCsvBtn: "export-csv-btn",
  exposureTable: "exposure-table",
  lateInjuryBtn: "late-injury-out-btn",
  lateInjuryModal: "late-injury-modal",
  lateInjurySearch: "late-injury-search",
  lateInjuryConfirm: "late-injury-confirm-btn",
  // AI
  aiRunBtn: "ai-run-analysis-btn",
  aiReport: "ai-report-panel",
  // War Room (Contest Sizing + Late Swap)
  contestFieldSize: "contest-field-size",
  contestMaxEntries: "contest-max-entries",
  contestPresetSelect: "contest-preset-select",
  contestRunBtn: "contest-run-btn",
  contestReport: "contest-report",
  lateSwapRunBtn: "late-swap-run-btn",
  lateSwapReport: "late-swap-report",
  lateSwapAutoToggle: "late-swap-auto-toggle",
  // Compliance
  complianceBanner: "compliance-banner",
  complianceTouchCount: "compliance-touch-count",
  // Fingerprint Variance™
  fingerprintSlider: "fingerprint-slider",
  fingerprintRotateBtn: "fingerprint-rotate-btn",
  fingerprintSaltBadge: "fingerprint-salt-badge",
  // Cluster Rotation™
  clusterRotationToggle: "cluster-rotation-toggle",
  clusterRotationProjBand: "cluster-rotation-proj-band",
  clusterRotationSalaryBand: "cluster-rotation-salary-band",
  clusterRotationSwapProb: "cluster-rotation-swap-prob",
  clusterRotationStats: "cluster-rotation-stats",
  // Group Rules
  flexBiasSelect: "flex-bias-select",
  teamCapInput: "team-cap-input",
  // Diversity Score
  diversityCard: "diversity-card",
  diversityScore: "diversity-score",
  diversityRefreshBtn: "diversity-refresh-btn",
  // Slate Attack Plan
  attackPlanBtn: "attack-plan-btn",
  attackPlanBody: "attack-plan-body",
  // Injury Feed
  injuryPanel: "injury-panel",
  injurySlateMatches: "injury-slate-matches",
  injurySyncModalBtn: "injury-sync-modal-btn",
  // Strategy Mode banner (small vs. mid vs. large field)
  strategyBanner: "strategy-mode-banner",
  strategyModeLabel: "strategy-mode-label",
  // Portfolio Split
  portfolioSplitPanel: "portfolio-split-panel",
  portfolioSplitGenerate: "portfolio-split-generate",
  // Contest Simulator
  contestSimulator: "contest-simulator",
  contestSimRun: "contest-sim-run",
  contestSimPortfolio: "contest-sim-portfolio",
  // Kickoff Countdown
  kickoffCountdown: "kickoff-countdown",
  kickoffCountdownValue: "kickoff-countdown-value",
  kickoffNotifyToggle: "kickoff-notify-toggle",
  kickoffSettingsToggle: "kickoff-settings-toggle",
  kickoffSettingsPanel: "kickoff-settings-panel",
  // Auto Attack Plan
  autoPlanToggle: "auto-plan-toggle",
  autoPlanArmed: "auto-plan-armed",
};
